<header class="header">
  <div class="container">
    <a class="brand" routerLink="/">
      <img src="assets/Logo.png" alt="Safroo Logo" class="logo" />
    </a>

    <button class="menu-toggle" 
    (click)="toggleMenu()" 
    aria-label="Toggle navigation" 
    [attr.aria-expanded]="isMenuOpen">
<span></span>
<span></span>
<span></span>
</button>


    <nav class="nav" [class.open]="isMenuOpen">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="isMenuOpen=false">Home</a>
      <a routerLink="/about" routerLinkActive="active" (click)="isMenuOpen=false">About</a>
      <a routerLink="/mission" routerLinkActive="active" (click)="isMenuOpen=false">Our Mission</a>
      <a routerLink="/contact" routerLinkActive="active" (click)="isMenuOpen=false">Contact Us</a>
    </nav>
  </div>
</header>
